// src/pages/Appointments/Admin/VisitTracking/VisitStats.jsx
import React from "react";
import { FiClock, FiActivity, FiAlertCircle } from "react-icons/fi";

const VisitStats = ({ visit, duration, scheduledDuration }) => {
  const getTimeStatus = () => {
    if (duration > scheduledDuration + 15) {
      return {
        color: "orange",
        icon: FiAlertCircle,
        label: "Running Over",
      };
    }
    if (duration > scheduledDuration) {
      return {
        color: "yellow",
        icon: FiClock,
        label: "Near Schedule",
      };
    }
    return {
      color: "green",
      icon: FiClock,
      label: "On Time",
    };
  };

  const timeStatus = getTimeStatus();
  const StatusIcon = timeStatus.icon;

  return (
    <div className="grid grid-cols-3 gap-4">
      {/* Duration */}
      <div className="bg-neutral-light rounded-lg p-3">
        <div className="flex items-center gap-2 mb-1">
          <FiClock className={`text-${timeStatus.color}-600`} size={16} />
          <span className="text-xs text-neutral-dark">Duration</span>
        </div>
        <p className={`text-xl font-bold text-${timeStatus.color}-700`}>
          {duration} min
        </p>
        <p className="text-xs text-neutral-dark mt-1">
          Scheduled: {scheduledDuration} min
        </p>
      </div>

      {/* Activities */}
      <div className="bg-neutral-light rounded-lg p-3">
        <div className="flex items-center gap-2 mb-1">
          <FiActivity className="text-blue-600" size={16} />
          <span className="text-xs text-neutral-dark">Activities</span>
        </div>
        <p className="text-xl font-bold text-blue-700">
          {(visit.activities?.productsViewed?.length || 0) +
            (visit.activities?.productsTriedOn?.length || 0)}
        </p>
        <p className="text-xs text-neutral-dark mt-1">
          {visit.activities?.productsViewed?.length || 0} viewed •{" "}
          {visit.activities?.productsTriedOn?.length || 0} tried
        </p>
      </div>

      {/* Status */}
      <div className="bg-neutral-light rounded-lg p-3">
        <div className="flex items-center gap-2 mb-1">
          <StatusIcon className={`text-${timeStatus.color}-600`} size={16} />
          <span className="text-xs text-neutral-dark">Status</span>
        </div>
        <p className={`text-xl font-bold text-${timeStatus.color}-700`}>
          {timeStatus.label}
        </p>
        <p className="text-xs text-neutral-dark mt-1">
          {duration > scheduledDuration
            ? `+${duration - scheduledDuration} min`
            : `${scheduledDuration - duration} min left`}
        </p>
      </div>
    </div>
  );
};

export default VisitStats;
